import { IInitalState } from './types';

export const initialState: IInitalState = {
  isFilterOnUsers: {
    userUid: undefined,
  },
};
